import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import { Link } from "react-router-dom";
import { Calendar, Laptop, Settings, Globe, ShieldCheck, Zap, Map } from "lucide-react";

function Services() {
  const services = [
    {
      title: "SGE Pro (Eventos)",
      text: "Nossa flagship. Gestão completa de reservas, mapa de stands e logística técnica para eventos de elite.",
      icon: <Calendar size={32} />,
      link: "/sge-pro"
    },
    {
      title: "Software Sob Medida",
      text: "Engenharia de alta densidade. Desenvolvemos sistemas críticos, CRMs técnicos e automações industriais.",
      icon: <Laptop size={32} />,
      link: "/sistemas-personalizados"
    },
    {
      title: "Mapeamento e Logística",
      text: "Sistemas especializados em controle de áreas, fluxos de pessoas e gerenciamento de ativos móveis.",
      icon: <Map size={32} />,
      link: "/sge-pro"
    },
    {
      title: "APIs e Segurança",
      text: "Integrações robustas com foco em governança de dados, LGPD e performance enterprise.",
      icon: <ShieldCheck size={32} />,
    }
  ];

  const valueProps = [
     { title: "Mapeamento Real-Time", icon: <Zap size={20} /> },
     { title: "Segurança de Dados", icon: <ShieldCheck size={20} /> },
     { title: "Gestão de Ativos", icon: <Settings size={20} /> },
     { title: "Contratos Dinâmicos", icon: <Globe size={20} /> },
  ];

  return (
    <section id="services" className="services-unified py-20">
      <Container>
        <div className="text-center mb-10" data-aos="fade-up" data-aos-duration="600">
           <h6 className="text-gold text-uppercase fw-bold mb-3 ls-3">Nossas Soluções</h6>
           <h2 className="section-title-premium text-white">Arquitetura de <span className="highlight-gold">Resultados</span></h2>
           <p className="section-subtitle-premium mx-auto max-w-700 text-white-50">
             Não trabalhamos com o genérico. Construímos os sistemas que sustentam as operações 
             mais complexas do mercado de eventos e indústria.
           </p>
        </div>

        <Row className="g-4 mb-5">
          {services.map((service, index) => (
            <Col lg={3} md={6} key={index} data-aos="fade-up" data-aos-duration="400">
              <Link to={service.link || "#"} className="service-card-unified h-100">
                <div className="service-icon-wrap">{service.icon}</div>
                <h5 className="service-title-text">{service.title}</h5>
                <p className="service-desc-text">{service.text}</p>
                <div className="hover-indicator"></div>
              </Link>
            </Col>
          ))}
        </Row>

        <Row className="justify-content-center mt-10">
           {valueProps.map((vp, idx) => (
             <Col xs={6} md={3} key={idx} className="text-center" data-aos="zoom-in" data-aos-duration="400">
                <div className="vp-item d-flex align-items-center justify-content-center gap-2">
                   <div className="text-gold">{vp.icon}</div>
                   <span className="small fw-bold opacity-80 text-uppercase ls-1 text-white">{vp.title}</span>
                </div>
             </Col>
           ))}
        </Row>
      </Container>

      <style>{`
        .services-unified {
          background-color: transparent;
          padding-top: 10rem !important;
          padding-bottom: 10rem !important;
          position: relative;
        }
        .service-card-unified {
          background: rgba(15, 15, 15, 0.4);
          backdrop-filter: blur(20px);
          border: 1px solid rgba(255, 255, 255, 0.05);
          border-radius: 24px;
          padding: 3rem 1.5rem;
          display: flex;
          flex-direction: column;
          align-items: center;
          text-align: center;
          text-decoration: none;
          color: #fff;
          transition: all 0.4s ease;
          position: relative;
          overflow: hidden;
        }
        .service-card-unified:hover {
          background: rgba(228, 168, 122, 0.05);
          border-color: #e4a87a;
          transform: translateY(-10px);
          color: #fff !important;
        }
        .service-icon-wrap {
          color: #e4a87a;
          background: rgba(228, 168, 122, 0.1);
          width: 65px;
          height: 65px;
          display: flex;
          align-items: center;
          justify-content: center;
          border-radius: 18px;
          margin-bottom: 2rem;
        }
        .service-card-unified:hover .service-icon-wrap { background: #e4a87a; color: #000; transform: scale(1.1); }
        .service-title-text { font-weight: 800; font-size: 1.1rem; margin-bottom: 1rem; color: #fff; }
        .service-desc-text { font-size: 0.85rem; opacity: 0.6; line-height: 1.6; color: #ccc; }
        .hover-indicator {
           position: absolute; bottom: 0; left: 0; width: 100%; height: 3px;
           background: #e4a87a; transform: scaleX(0); transition: transform 0.4s ease;
        }
        .service-card-unified:hover .hover-indicator { transform: scaleX(1); }
        .vp-item { padding: 1rem; opacity: 0.7; }
        .text-gold { color: #e4a87a; }
      `}</style>
    </section>
  );
}

export default Services;
